import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const

export type uscoCredType = (typeof credentialTypes)[number]
export const uscoDocumentTypes = [
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const usco: CarrierDef<uscoCredType> = {
  name: 'US Cargo',
  scac: 'usco',
  credentialTypes,
  legacyCredMap: [...userPassMap],
  engineLayers: ['documents'],
  documentTypes: uscoDocumentTypes,
}
